import Vue from "vue";
import Vuex from "vuex";
import pathify from "vuex-pathify";
import api from "@/api";

// Global state.
import global from "./global";

// Generic entity state manager.
import Entity from "./entity";

// Specific modules.
import card from "./creditCard";
import subscription from "./subscription";
import chargebee from "../utils/chargebee";
import organization from "./organization";
import recording from "../utils/recording";

// Prints pathify settings etc to the console debugger.
if (global.state.debug) {
  pathify.debug();
}

Vue.use(Vuex);

const basePropsToClean = [
  "@odata.context",
  "createdBy",
  "createdOn",
  "modifiedBy",
  "modifiedOn",
  "organizationId",
  "userId",
  "deleted",
  "deletedBy",
  "deletedOn"
];

const store = new Vuex.Store({
  ...global,
  modules: {
    card: card,
    subscription: subscription,
    apiKeys: new Entity("apiKeys", api.props.endPoints.apiKey, [
      ...basePropsToClean,
      "key"
    ]),
    applications: new Entity("applications", api.props.endPoints.application, [
      ...basePropsToClean,
      "applicationId"
    ]),
    channels: new Entity("channels", api.props.endPoints.channel, [
      ...basePropsToClean,
      "bandwidthAdaptationPolicy",
      "applicationConfigId",
      "channelIdPattern",
      "default"
    ]),
    webhooks: new Entity("webhooks", api.props.endPoints.channelWebhook, [
      ...basePropsToClean
    ]),
    // Extended webhooks; added to store default channel hooks when in application level
    webhooksExt: new Entity("webhooksExt", api.props.endPoints.channelWebhook, [
      ...basePropsToClean
    ]),
    chargebee: chargebee,
    appStats: new Entity("appStats", api.props.endPoints.appStats, [
      ...basePropsToClean
    ]),
    hourlyConnectionStats: new Entity(
      "hourlyConnectionStats",
      api.props.endPoints.dashboardQuery,
      [...basePropsToClean]
    ),
    dailyConnectionStats: new Entity(
      "dailyConnectionStats",
      api.props.endPoints.dashboardQuery,
      [...basePropsToClean]
    ),
    connectionStats: new Entity(
      "connectionStats",
      api.props.endPoints.dashboardQuery,
      [...basePropsToClean]
    ),
    channelStats: new Entity(
      "channelStats",
      api.props.endPoints.dashboardQuery,
      [...basePropsToClean]
    ),
    clientStats: new Entity("clientStats", api.props.endPoints.dashboardQuery, [
      ...basePropsToClean
    ]),
    organization: organization,
    recording: recording,
    user: new Entity("user", api.props.endPoints.user, [
      ...basePropsToClean,
      "firstName", // see LSC-887 re: why we strip these out.
      "lastName",
      "userName",
      "nickName",
      "emailAddress",
      "phoneNumber",
      "pictureUrl",
      "role"
    ])
  },
  plugins: [pathify.plugin]
});

export default store;
window.store = store;
